import * as constants from "./constants";

const initialState = {
  user: null,
  loading: false,
  logoutLoading: false,
  labs: [],
  labsLoading: false,
  isCollapsed: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.LOGIN:
      return {
        ...state,
        loading: true,
      };
    case constants.LOGIN_SUCCESS:
      const { user } = action.data;
      return {
        ...state,
        loading: false,
        user: {
          ...user,
          userType: user?.userType ? user?.userType : "client",
        },
      };
    case constants.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
      };
    case constants.LOGOUT:
      return {
        ...state,
        logoutLoading: true,
      };
    case constants.LOGOUT_SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        user: null,
      };
    case constants.LOGOUT_ERROR:
      return {
        ...state,
        logoutLoading: false,
      };
    case constants.SET_USER:
      return {
        ...state,
        user: action.data,
      };
    case constants.NAVBAR_SET_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.data,
      };
    case constants.FETCH_SIDEBAR_LABS:
      return {
        ...state,
        labsLoading: true,
      };
    case constants.FETCH_SIDEBAR_LABS_SUCCESS:
      // let projectsWithDocControlViewPermission = action.data.filter(        
      //   (el) => el?.permissions?.document_control?.view
      // );
      return {
        ...state,
        labsLoading: false,
        labs: action.data,
        // projects: projectsWithDocControlViewPermission,
      };
    case constants.FETCH_SIDEBAR_LABS_ERROR:
      return {
        ...state,
        labsLoading: false,
      };

    default:
      return state;
  }
};

export default authReducer;
